import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

// Pictograms for the trigger taxonomy (design spec § 01). Rendered through MUI
// SvgIcon so they accept `sx`/`fontSize` exactly like the other icons used
// across the editor. The shapes use stroke (not fill), so we force
// `fill: none` + `stroke: currentColor` on the root and let inner shapes that
// need a solid fill opt back in locally.
const STROKE_SX = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

const mergeSx = (sx: SvgIconProps['sx']) => ({
  ...STROKE_SX,
  ...((sx as object) ?? {}),
});

// AI trigger · area_entry — dashed zone + entry arrow + play point.
// "Player walks into the region → script auto-plays."
export const TriggerKindIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props} sx={mergeSx(props.sx)}>
    <circle cx="14.5" cy="12" r="7" strokeDasharray="3 3.3" />
    <path d="M1.5 12h9.5" />
    <path d="M7.8 8.8 11 12l-3.2 3.2" />
    <circle cx="16" cy="12" r="1.6" fill="currentColor" stroke="none" />
  </SvgIcon>
);

// Spot · ui_click — Noa panel bubble + button bar.
// "Appears as a button in Noa's panel → plays on tap."
export const SpotKindIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props} sx={mergeSx(props.sx)}>
    <path d="M21 11.5a2.5 2.5 0 0 1-2.5 2.5H12.5L8 18.5V14H5.5A2.5 2.5 0 0 1 3 11.5v-5A2.5 2.5 0 0 1 5.5 4h13A2.5 2.5 0 0 1 21 6.5z" />
    <rect
      x="8"
      y="7.4"
      width="8"
      height="3.4"
      rx="1.7"
      fill="currentColor"
      stroke="none"
    />
  </SvgIcon>
);
